import React from 'react';

import { Button, Group, Paper, Text, useMantineTheme } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

interface IAthleteListActionBannerProps {
  message: string;
  actionLabel: string;
  onAction: () => void;
  bannerDataCy: string;
  buttonDataCy: string;
}

const AthleteListActionBanner = ({
  message,
  actionLabel,
  onAction,
  bannerDataCy,
  buttonDataCy,
}: IAthleteListActionBannerProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Paper
      px='lg'
      py='md'
      radius={0}
      sx={{
        backgroundColor: '#dcf5ff',
        borderBottom: `1px solid ${theme.colors.kiloBlue[7]}`,
      }}
      data-cy={bannerDataCy}
    >
      <Group position='apart' noWrap>
        <Text fw={500}>{message}</Text>
        <Button
          rightIcon={<IconArrowRight size={theme.fontSizes.md} />}
          onClick={onAction}
          data-cy={buttonDataCy}
        >
          {actionLabel}
        </Button>
      </Group>
    </Paper>
  );
};

export default AthleteListActionBanner;
